import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import vendorService from '../../services/vendorService';
import ChatButton from '../../components/Chat/ChatButton';
import './VendorDetail.css';
import CommonModal from '../../services/CommonModal';

const VendorDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showChat, setShowChat] = useState(false);
  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    fetchVendorDetails();
  }, [id]);

  const fetchVendorDetails = async () => {
    try {
      setLoading(true);
      const data = await vendorService.getVendorById(id);
      setVendor(data);
      setError(null);
    } catch (err) {
      setError('Failed to fetch vendor details');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  const confirmDelete = () => {
    console.log("uuuu")
    handleDelete(selectedVendorId);
    setShowDeleteModal(false);
    setSelectedVendorId(null);
  };


  const handleDelete = async () => {
    console.log("oooo")

    try {
      await vendorService.deleteVendor(id);
      navigate('/app/vendors');
    } catch (err) {
      alert('Failed to delete vendor');
      console.error(err);
    }
  };

  const getStatusBadgeClass = (status) => {
    const statusClasses = {
      'Pending': 'badge-warning',
      'Under Review': 'badge-info',
      'Approved': 'badge-success',
      'Active': 'badge-success',
      'Suspended': 'badge-danger',
      'Rejected': 'badge-danger',
      'Inactive': 'badge-secondary'
    };
    return statusClasses[status] || 'badge-secondary';
  };

  if (loading) {
    return <div className="loading">Loading vendor details...</div>;
  }

  if (error || !vendor) {
    return (
      <div className="error-container">
        <p>{error || 'Vendor not found'}</p>
        <Link to="/app/vendors" className="btn btn-primary">
          Back to Vendors
        </Link>
      </div>
    );
  }

  const token = localStorage.getItem('token');

  return (
    <div className="vendor-detail-page">
      <div className="page-header">
        <div className="header-left">
          <Link to="/app/vendors" className="back-link">
            <i className="fas fa-arrow-left"></i> Back to Vendors
          </Link>
          <h1>{vendor.company_name}</h1>
          <span className={`badge ${getStatusBadgeClass(vendor.status)}`}>
            {vendor.status}
          </span>
        </div>
        <div className="header-actions">
          <button
            onClick={() => setShowChat(true)}
            className="btn btn-primary"
            title="Chat with vendor"
          >
            <i className="fas fa-comments"></i> Chat
          </button>
          <Link
            to={`/app/vendors/${id}/edit`}
            className="btn btn-warning"
          >
            <i className="fas fa-edit"></i> Edit
          </Link>
          <button
            onClick={() => {
              console.log("kkk")
              setSelectedVendorId(vendor.id);
              setShowDeleteModal(true);
            }}
            className="btn btn-danger"
          >
            <i className="fas fa-trash"></i> Delete
          </button>
        </div>
      </div>

      <div className="vendor-detail-content">
        {/* Basic Information */}
        <div className="detail-section">
          <h2>Basic Information</h2>
          <div className="detail-grid">
            <div className="detail-item">
              <label>Vendor Code</label>
              <p>{vendor.vendor_code}</p>
            </div>
            <div className="detail-item">
              <label>Company Name</label>
              <p>{vendor.company_name}</p>
            </div>
            <div className="detail-item">
              <label>Legal Name</label>
              <p>{vendor.legal_name || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>Vendor Type</label>
              <p>{vendor.vendor_type || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>Category</label>
              <p>{vendor.category}</p>
            </div>
            <div className="detail-item">
              <label>Status</label>
              <p>
                <span className={`badge ${getStatusBadgeClass(vendor.status)}`}>
                  {vendor.status}
                </span>
              </p>
            </div>
            <div className="detail-item">
              <label>Onboarding Status</label>
              <p>{vendor.onboarding_status || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>Rating</label>
              <p>
                {vendor.rating ? (
                  <span className="rating">
                    {'★'.repeat(vendor.rating)}
                    {'☆'.repeat(5 - vendor.rating)}
                  </span>
                ) : (
                  'Not rated'
                )}
              </p>
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <div className="detail-section">
          <h2>Contact Information</h2>
          <div className="detail-grid">
            <div className="detail-item">
              <label>Email</label>
              <p>
                <a href={`mailto:${vendor.email}`}>{vendor.email}</a>
              </p>
            </div>
            <div className="detail-item">
              <label>Phone</label>
              <p>{vendor.phone || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>Website</label>
              <p>
                {vendor.website ? (
                  <a href={vendor.website} target="_blank" rel="noopener noreferrer">
                    {vendor.website}
                  </a>
                ) : (
                  'N/A'
                )}
              </p>
            </div>
          </div>
        </div>

        {/* Address Information */}
        <div className="detail-section">
          <h2>Address</h2>
          <div className="detail-grid">
            <div className="detail-item full-width">
              <label>Street Address</label>
              <p>{vendor.address || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>City</label>
              <p>{vendor.city || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>State</label>
              <p>{vendor.state || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>Country</label>
              <p>{vendor.country || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>Postal Code</label>
              <p>{vendor.postal_code || 'N/A'}</p>
            </div>
          </div>
        </div>

        {/* Financial Information */}
        <div className="detail-section">
          <h2>Financial Information</h2>
          <div className="detail-grid">
            <div className="detail-item">
              <label>Tax ID</label>
              <p>{vendor.tax_id || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>Registration Number</label>
              <p>{vendor.registration_number || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>Bank Name</label>
              <p>{vendor.bank_name || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>Payment Terms</label>
              <p>{vendor.payment_terms || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>Currency</label>
              <p>{vendor.currency || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>Credit Limit</label>
              <p>{vendor.credit_limit ? `$${vendor.credit_limit.toLocaleString()}` : 'N/A'}</p>
            </div>
          </div>
        </div>

        {/* Additional Information */}
        {vendor.notes && (
          <div className="detail-section">
            <h2>Notes</h2>
            <p className="notes-content">{vendor.notes}</p>
          </div>
        )}

        {/* Tags */}
        {Array.isArray(vendor.tags) && vendor.tags.length > 0 && (
          <div className="detail-section">
            <h2>Tags</h2>
            <div className="tags-container">
              {vendor.tags.map((tag, index) => (
                <span key={index} className="tag">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Chat Modal */}
      {showChat && vendor && user && token && (
        <ChatButton
          vendor={vendor}
          currentUser={user}
          token={token}
          onClose={() => setShowChat(false)}
        />
      )}
      <CommonModal
        isOpen={showDeleteModal}
        title="Delete Vendor"
        message="Are you sure you want to delete this vendor?"
        onClose={() => {
          setShowDeleteModal(false);
          setSelectedVendorId(null);
        }}
        onConfirm={confirmDelete}
        type="error"
        confirmText="Delete"
        cancelText="Cancel"
      />
    </div>

  );

};

export default VendorDetail;

// Made with Bob